module.exports = __webpack_public_path__ + "static/media/vi-data-roaming-other_1.feb4bfba.png";